import { Component, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { GraduationMessageService } from '@components/graduation-message/graduation-message.service';
import { AuthUserService } from '@services/auth-user.service';
import { SlideMenuService } from '@services/slide-menu.service';

@Component({
  selector: 'app-student-sidebar',
  templateUrl: './student-sidebar.component.html',
  styleUrls: ['./student-sidebar.component.scss'],
  standalone: false,
})
export class StudentSidebarComponent implements OnInit {
  authUserService = inject(AuthUserService);
  slideMenuService = inject(SlideMenuService);
  private graduationMessageService = inject(GraduationMessageService);

  statisticsSubscription: Subscription;
  isDeliveredGraduationMessage = false;

  ngOnInit(): void {
    this.graduationMessageService.getStudentIsDeliverdGraduationMessages().subscribe((response) => {
      this.isDeliveredGraduationMessage = response.is_delivered;
    });
  }

  hideSidebar() {
    this.slideMenuService.slideOut();
  }
}
